export default (props) => {
  const { color, width, height } = props;
  const colorInput = color || "#EA1A21";
  const widthInput = width || 16;
  const heightInput = height || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={widthInput}
      height={heightInput}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6617_49391)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.08629 11.3781C4.97764 11.3327 4.87911 11.2661 4.79641 11.1822C4.71256 11.0995 4.64598 11.001 4.60053 10.8924C4.55509 10.7837 4.53168 10.6671 4.53168 10.5493C4.53168 10.4316 4.55509 10.315 4.60053 10.2063C4.64598 10.0977 4.71256 9.99914 4.79641 9.91645L6.71286 8L4.79641 6.08356C4.7133 6.00045 4.64737 5.90178 4.60239 5.79319C4.55741 5.6846 4.53426 5.56821 4.53426 5.45067C4.53426 5.33313 4.55741 5.21675 4.60239 5.10815C4.64737 4.99956 4.7133 4.90089 4.79641 4.81778C4.87953 4.73467 4.97819 4.66874 5.08679 4.62376C5.19538 4.57878 5.31176 4.55563 5.4293 4.55563C5.54684 4.55563 5.66323 4.57878 5.77182 4.62376C5.88041 4.66874 5.97908 4.73467 6.06219 4.81778L7.97864 6.73423L9.89508 4.81778C9.97819 4.73467 10.0769 4.66874 10.1855 4.62376C10.294 4.57878 10.4104 4.55563 10.528 4.55563C10.6455 4.55563 10.7619 4.57878 10.8705 4.62376C10.9791 4.66874 11.0777 4.73467 11.1609 4.81778C11.244 4.90089 11.3099 4.99956 11.3549 5.10815C11.3999 5.21675 11.423 5.33313 11.423 5.45067C11.423 5.56821 11.3999 5.6846 11.3549 5.79319C11.3099 5.90178 11.244 6.00045 11.1609 6.08356L9.24441 8L11.1609 9.91645C11.3287 10.0843 11.423 10.312 11.423 10.5493C11.423 10.7867 11.3287 11.0144 11.1609 11.1822C10.993 11.3501 10.7653 11.4444 10.528 11.4444C10.2906 11.4444 10.0629 11.3501 9.89508 11.1822L7.97864 9.26578L6.06219 11.1822C5.9795 11.2661 5.88096 11.3327 5.77231 11.3781C5.66367 11.4236 5.54707 11.447 5.4293 11.447C5.31153 11.447 5.19494 11.4236 5.08629 11.3781Z"
          fill={colorInput}
        />
      </g>
      <defs>
        <clipPath id="clip0_6617_49391">
          <rect width={widthInput} height={heightInput} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
